export function isNumeric(value: unknown) {
  if (value === undefined || value === null) return false
  if (value === '') return false

  return !Number.isNaN(Number(value))
}
